import { ContractNegotiationVersion } from '../models/Entities/Contracts/ContractNegotiationVersion';
import { NewContractNegotiationVersion } from '../models/Entities/Contracts/NewContractNegotiationVersion';
import { IResult } from '../models/HttpResult';
import * as Functions from '../functions/common';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/';

const GetRequestConfig = (token: string, method?: string, body?: unknown): RequestInit => ({
  method,
  body: body !== undefined ? JSON.stringify(body) : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  },
});

const HandleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    throw response;
  }

  const data = (await response.json()) as IResult<T>;
  return data.data;
};

const HandleError = async (error: any) => {
  const body = await error.text();
  throw Functions.HttpErrorHandler(body, error);
};

export const GetContractNegotiationVersions = async (contractNegotiationId: string, token: string): Promise<ContractNegotiationVersion[]> => {
  const requestUrl = BaseURL + 'negotiations/' + contractNegotiationId + '/versions/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiationVersion[]>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const GetContractNegotiationVersionById = async (id: string, token: string): Promise<ContractNegotiationVersion> => {
  const requestUrl = BaseURL + 'negotiations/versions/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiationVersion>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const CreateContractNegotiationVersion = async (contractNegotiationVersion: NewContractNegotiationVersion, token: string): Promise<ContractNegotiationVersion> => {
  const requestUrl = BaseURL + 'negotiations/versions/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'POST', contractNegotiationVersion))
      .then((response) => HandleResponse<ContractNegotiationVersion>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const UpdateContractNegotiationVersion = async (contractNegotiationVersion: ContractNegotiationVersion, token: string): Promise<ContractNegotiationVersion> => {
  const requestUrl = BaseURL + 'negotiations/versions/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'PUT', contractNegotiationVersion))
      .then((response) => HandleResponse<ContractNegotiationVersion>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const DeleteContractNegotiationVersion = async (id: string, token: string): Promise<string> => {
  const requestUrl = BaseURL + 'negotiations/versions/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'DELETE'))
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return id;
      })
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};